var _path, _path2, _path3, _path4, _path5, _path6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEstateBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 16,
    height: 16,
    viewBox: "0 0 80 80",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M4.5 66.5L4.5 7.5 12.5 7.5 12.5 3.5 43.5 3.5 43.5 7.5 51.5 7.5 51.5 66.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7496c4",
    d: "M43,4v3v1h1h7v58H5V8h7h1V7V4H43 M44,3H12v4H4v60h48V7h-8V3L44,3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#74b0d4",
    d: "M12,17h8v-2h-8V17z M24,17h8v-2h-8V17z M36,15v2h8v-2H36z M12,23h8v-2h-8V23z M24,23h8v-2h-8V23z M36,23h8v-2h-8V23z M12,29h8v-2h-8V29z M24,29h8v-2h-8V29z M12,35h8v-2h-8V35z M24,35h8v-2h-8V35z M12,41h8v-2h-8V41z M24,41h8 v-2h-8V41z M12,47h8v-2h-8V47z M24,47h8v-2h-8V47z M12,53h8v-2h-8V53z M24,53h8v-2h-8V53z M12,59h8v-2h-8V59z M24,59h8v-2h-8V59z M36,29h8v-2h-8V29z M36,35h2v-2h-2V35z M36,41h2v-2h-2V41z M36,47h2v-2h-2V47z M36,53h2v-2h-2V53z M36,59h2v-2h-2V59z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M38,67h8v-2h-8V67z M50,25v8.462h2V25H50z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8bb7f0",
    d: "M40.5 76.5L40.5 31.5 46.5 31.5 46.5 27.5 69.5 27.5 69.5 31.5 75.5 31.5 75.5 76.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M69,28v3v1h1h5v44H41V32h5h1v-1v-3H69 M70,27H46v4h-6v46h36V31h-6V27L70,27z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M60,37v2h8v-2H60z M48,39h8v-2h-8V39z M60,43h8v-2h-8V43z M48,43h8v-2h-8V43z M60,47h8v-2h-8V47z M48,47h8v-2h-8V47z M60,51h8v-2h-8V51z M48,51h8v-2h-8V51z M60,55h8v-2h-8V55z M48,55h8v-2h-8V55z M60,59h8v-2h-8V59z M48,59h8 v-2h-8V59z M60,63h8v-2h-8V63z M48,63h8v-2h-8V63z M60,67h8v-2h-8V67z M48,67h8v-2h-8V67z M60,71h8v-2h-8V71z M48,71h8v-2h-8V71z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstateBuilding);
export default __webpack_public_path__ + "static/media/estate_building.45c6730310341fdeedf854cd418304df.svg";
export { ForwardRef as ReactComponent };